// Metadáta stavu prípravy objednávky pre AdminUI. Zrkadlí backend
// (helper/dsok/orderEvents/preparationStatus.js) — stavy, povolené prechody,
// dôvody zrušenia — a dopĺňa podkladové farby a i18n kľúče pre zobrazenie.
//
// preparationStatus je stav, ktorý zaujíma objednávateľa (guesta) a riadi
// notifikácie. Nezamieňať s orderStatus (interný stav platby/integrácií).

export const PREPARATION_STATUSES = {
  IN_PROGRESS: "inProgress",
  READY: "ready",
  COMPLETED: "completed",
  CANCELED: "canceled",
};

export const PREPARATION_STATUS_LIST = [
  PREPARATION_STATUSES.IN_PROGRESS,
  PREPARATION_STATUSES.READY,
  PREPARATION_STATUSES.COMPLETED,
  PREPARATION_STATUSES.CANCELED,
];

// Povolené prechody:
//   inProgress ──▶ ready ──▶ completed
//        │           │
//        └───────────┴────▶ canceled
// completed a canceled sú koncové.
export const ALLOWED_TRANSITIONS = {
  [PREPARATION_STATUSES.IN_PROGRESS]: [
    PREPARATION_STATUSES.READY,
    PREPARATION_STATUSES.CANCELED,
  ],
  [PREPARATION_STATUSES.READY]: [
    PREPARATION_STATUSES.COMPLETED,
    PREPARATION_STATUSES.CANCELED,
  ],
  [PREPARATION_STATUSES.COMPLETED]: [],
  [PREPARATION_STATUSES.CANCELED]: [],
};

// Stavy, pri ktorých sa guestovi posiela notifikácia (a teda dá zmysel ju
// poslať znova). Zrkadlí backend NOTIFIABLE_PREPARATION_STATUSES.
export const NOTIFIABLE_PREPARATION_STATUSES = [
  PREPARATION_STATUSES.READY,
  PREPARATION_STATUSES.CANCELED,
];

export const isNotifiablePreparationStatus = (status) =>
  NOTIFIABLE_PREPARATION_STATUSES.includes(status);

// Dôvod zrušenia je povinný pri prechode na "canceled".
export const CANCEL_REASON_CODES = [
  "out_of_stock",
  "kitchen_issue",
  "customer_request",
  "payment_issue",
  "other",
];

// Logické podkladové farby: inProgress = jantárová (prebieha príprava),
// ready = zelená (pripravená), completed = neutrálna sivá (uzavreté),
// canceled = červená (zrušené).
const STATUS_COLORS = {
  [PREPARATION_STATUSES.IN_PROGRESS]: {
    bg: "#FEF3C7",
    color: "#92400E",
    border: "#FCD34D",
  },
  [PREPARATION_STATUSES.READY]: {
    bg: "#DCFCE7",
    color: "#166534",
    border: "#86EFAC",
  },
  [PREPARATION_STATUSES.COMPLETED]: {
    bg: "#E5E7EB",
    color: "#374151",
    border: "#D1D5DB",
  },
  [PREPARATION_STATUSES.CANCELED]: {
    bg: "#FEE2E2",
    color: "#991B1B",
    border: "#FCA5A5",
  },
};

const FALLBACK_COLOR = { bg: "#E5E7EB", color: "#374151", border: "#D1D5DB" };

/** Podkladová/textová farba pre daný stav. */
export const preparationStatusColor = (status) =>
  STATUS_COLORS[status] || FALLBACK_COLOR;

/** i18n kľúč názvu stavu. */
export const preparationStatusLabelKey = (status) =>
  `pages.dsokOrders.preparationManagement.statuses.${status}`;

/** i18n kľúč názvu dôvodu zrušenia. */
export const cancelReasonLabelKey = (code) =>
  `pages.dsokOrders.preparationManagement.cancelReasons.${code}`;

/**
 * Ktoré cieľové stavy sú z aktuálneho povolené.
 * Neznámy/chýbajúci stav (staré objednávky) — backend povolí ktorýkoľvek platný
 * prechod, preto ponúkneme všetky okrem toho aktuálneho.
 */
export const allowedNextStatuses = (currentStatus) => {
  if (currentStatus && ALLOWED_TRANSITIONS[currentStatus]) {
    return ALLOWED_TRANSITIONS[currentStatus];
  }
  return PREPARATION_STATUS_LIST.filter((s) => s !== currentStatus);
};

/** Je stav koncový (žiadny povolený prechod)? */
export const isTerminalPreparationStatus = (status) =>
  Array.isArray(ALLOWED_TRANSITIONS[status]) &&
  ALLOWED_TRANSITIONS[status].length === 0;
